































































import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import {
    IOmnichannelStrategyFilters,
    IOmnichannelStrategySaveDto,
    IOmnichannelStrategyTableDto,
} from '@/pages/omnichannel-strategy/types/data';
import OmnichannelStrategyApi from '@/pages/omnichannel-strategy/api/OmnichannelStrategyApi';
import OmnichannelStrategyFilters from '@/pages/omnichannel-strategy/tabs/strategy/OmnichannelStrategyFilters.vue';
import OmnichannelStrategyModal from '@/pages/omnichannel-strategy/tabs/strategy/OmnichannelStrategyModal.vue';
import OmnichannelStrategyTable from '@/pages/omnichannel-strategy/tabs/strategy/OmnichannelStrategyTable.vue';
import OmnichannelProductsList from '@/pages/omnichannel-strategy/tabs/products/OmnichannelProductsList.vue';
import OmnichannelRulesListTab from '@/pages/omnichannel-strategy/tabs/rules/OmnichannelRulesListTab.vue';
import {Component, Mixins} from 'vue-property-decorator';
import MarketSelect from '@/components/MarketSelect.vue';
import {SelectMarket} from '@/interfaces/global-data';

@Component({
    components: {
        MarketSelect,
        OmnichannelStrategyFilters,
        OmnichannelStrategyModal,
        OmnichannelStrategyTable,
        OmnichannelProductsList,
    },
})
export default class OmnichannelStrategyPage extends Mixins(LocalData, Http) {

    private activeTabKey: string = 'strategiesListTab';

    private selectedStrategiesForProductList: IOmnichannelStrategyTableDto[] = [];
    private selectedStrategiesFromTable: IOmnichannelStrategyTableDto[] = [];
    private openProductListWithSelectedStrategy: boolean = false;

    private filters: IOmnichannelStrategyFilters = {
        market: null,
        groupOfProduct: -1,
        categoryOfProduct: -1,
        subcategory: -1,
        formatSelected: -1,
        regionSelected: -1,
        clusterSelected: -1,
    };

    private isFiltersSelected: boolean = false;

    private api: OmnichannelStrategyApi = new OmnichannelStrategyApi({parent: this})

    created() {
        const json = localStorage.getItem('omnichannelStrategy')
        if (json != null) {
            this.filters = JSON.parse(json);
        }
    }

    private strategySaved() {
        (this.$refs.strategyTable as any).refreshOmnicalStrategyListBySelectedFilters()
    }

    private onEditStrategy(payload: IOmnichannelStrategySaveDto) {
        (this.$refs.omnichannelEditModal as OmnichannelStrategyModal).updateStrategy(payload);
    }

    private onFilterSelecting(event: boolean) {
        this.isFiltersSelected = event;
    }

    private onFiltersUpdated(newVal: IOmnichannelStrategyFilters) {
        if (typeof newVal !== 'undefined') {
            this.selectedStrategiesForProductList = [];
            this.selectedStrategiesFromTable = [];
            (this.$refs.strategyTable as OmnichannelStrategyTable).clearSelection();
            (this.$refs.strategyTable as OmnichannelStrategyTable).$forceUpdate()
            localStorage.setItem('omnichannelStrategy', JSON.stringify(newVal));
        }
    }

    private onStrategySelectionChange(strategies: IOmnichannelStrategyTableDto[]) {
        this.selectedStrategiesFromTable = strategies;
    }

    private handleSelectedTabsChange(key: string) {
        this.activeTabKey = key;
        if (key === 'productsListTab') {
            if (!this.openProductListWithSelectedStrategy) {
                this.selectedStrategiesForProductList = [...this.selectedStrategiesFromTable];
            }
            this.openProductListWithSelectedStrategy = false;
            this.$nextTick(() => {
                (this.$refs.productsListRef as OmnichannelProductsList).prepareAndFetchSkuList();
            });
        }
    }

    private onGoToProductList(strategy: IOmnichannelStrategyTableDto) {
        this.openProductListWithSelectedStrategy = true;
        this.selectedStrategiesForProductList = [strategy];
        this.activeTabKey = 'productsListTab';
        this.$nextTick(() => {
          (this.$refs.productsListRef as OmnichannelProductsList).prepareAndFetchSkuList();
        });
    }

    private updateSelectMarket(market: SelectMarket) {
        if (this.filters.market == null || this.filters.market.id !== market.id) {
            this.selectedStrategiesForProductList = [];
            this.selectedStrategiesFromTable = [];
            (this.$refs.strategyTable as OmnichannelStrategyTable).clearSelection();
            this.filters = {
                ...this.filters,
                market,
                groupOfProduct: -1,
                categoryOfProduct: -1,
                subcategory: -1,
                formatSelected: -1,
                regionSelected: -1,
                clusterSelected: -1,
            };
        }
    }
}
